export default "/kiban/_next/static/images/02_flexible-22b670e4028063870504976d3bcdb105.png";